import { RootState } from "../reducers"

export const selectUser = (state: RootState) => state.user
export const selectUserPermissions = (state: RootState) =>
	state.user.entry.permissions ?? []
export const selectUserGroups = (state: RootState) =>
	state.user.entry.groups ?? []
export const selectDefaultUserBuilding = (state: RootState) =>
	state.user.entry.building
